import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@formrails/environments';

@Pipe({
  name: 'imgUrl',
  standalone: true
})
export class ImgUrlPipe implements PipeTransform {
  private readonly documentApiUrl = `${environment.documentApi}/document`;

  transform(value: string): string {
    return `${this.documentApiUrl}/${value}`;
  }
}
